// React
import { useCallback } from 'react'

// Models
import { useStores } from 'models'

// Interfaces
import {
  ICertificationWebpageSupportDocumentDownloadDocumentAttrs,
  ICertificationWebpageSupportDocumentGetListAttrs,
} from 'interfaces/webpage/certification/registration/precondition'

const useCertificationSupportDocument = () => {
  // Hook
  const {
    certificationWebpageSupportDocument: {
      certificationWebpageSupportDocument_loading,
      certificationWebpageSupportDocument_list,
      certificationWebpageSupportDocument_CLEAR_LIST,
      certificationWebpageSupportDocument_fetchList: fetchList,
      certificationWebpageSupportDocument_downloadDocument: downloadDocument,
    },
  } = useStores()

  /**
   * @description Fetch relevant proof list
   *
   * @param {ICertificationWebpageSupportDocumentGetListAttrs} payload
   *
   * @return {Promise<void>} Promise<void>
   */
  const certificationWebpageSupportDocument_fetchList = useCallback(
    (payload: ICertificationWebpageSupportDocumentGetListAttrs): Promise<void> => {
      return new Promise((resolve, reject) => {
        fetchList({
          params: { ...payload.params },
          requestConfig: {
            ...payload.requestConfig,
          },
          onSuccess: resolve,
          onError: reject,
        })
      })
    },
    [fetchList],
  )

  /**
   * @description Download document of support document
   *
   * @param {ICertificationWebpageSupportDocumentDownloadDocumentAttrs} payload
   *
   * @return {Promise<void>} Promise<void>
   */
  const certificationWebpageSupportDocument_downloadDocument = useCallback(
    (payload: ICertificationWebpageSupportDocumentDownloadDocumentAttrs): Promise<void> => {
      return new Promise((resolve, reject) => {
        downloadDocument({
          params: { ...payload.params },
          requestConfig: {
            ...payload.requestConfig,
          },
          onSuccess: resolve,
          onError: reject,
        })
      })
    },
    [downloadDocument],
  )

  return {
    certificationWebpageSupportDocument_loading,
    certificationWebpageSupportDocument_list,
    certificationWebpageSupportDocument_CLEAR_LIST,
    certificationWebpageSupportDocument_fetchList,
    certificationWebpageSupportDocument_downloadDocument,
  }
}

export { useCertificationSupportDocument }
